import { ReactNode } from "react";
import styled from "styled-components";
import { Tabs, ITabsProps } from "./Tabs";

const Surface = styled.div`
	display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; min-width: 0;
	> div:last-child { padding: 20px; background: #f5f7fa; }
	@media(max-width: 600px) { > div:last-child { padding: 14px; } }
	/* Split views own both scroll areas, just like ClientSettingsPopup. */
	> div:last-child:has(.decta-sections-split) { padding: 0; overflow: hidden; }
`;

/** Decta content layout; navigation uses the same tabs as the rest of the app. */
export function OverflowTabs({ children }: { children: ReactNode }) {
	return <Surface><Tabs variant="modern" scrollable spaceBottom={0} sx={{ padding: "0 20px", background: "#fff" }}>
		{children as ITabsProps["children"]}
	</Tabs></Surface>;
}
